module.exports = __webpack_public_path__ + "static/media/allUserIcon.68548dc7.svg";